import { NotificationItem } from '../Types';
import { callApiWithResponseAsync } from './commonServices';

export async function getUsersNotificationsAsync(userId: string): Promise<NotificationItem[]> {
    return await callApiWithResponseAsync(`getUsersNotifications`, "/api/v1/metadata/notifications", {
        method: 'GET'      
    });
}
